<template lang="pug">
  .default-pdp-swatches(v-if="showSwatchSelector" :class="{ 'has-arrows': arrowsVisible }")
    horizontal-selector.swatches-wrap(:selected-index="selectedIndex"  :drag-mode="true"  :center-mode="false" @swipe-left="swipeLeft" @swipe-right="swipeRight" @overflow="setArrowsVisible")
      .swatch-wrap(v-for="prod in productsForProductType" :class="{ selected: prod.id == product.id }")
        a.swatch.xs-f-small.max-at-tweak(:href="'/product/' + prod.url_key" @click.prevent="selectProduct(prod)")
          img.swatch-image(:src="swatchImage(prod).url" :alt="prod.name")
          mr-icon.best(v-if="recommendedSwatch(prod)" name="heart" style="width: 1em;")
          span.ada-tooltip {{ prod.name }}
          span.ada-tooltip(v-if="prod.id == product.id") selected

    button.left-nav.btn-reset.text-center.clickable.xs-f-large.max-at-tweak(v-if="arrowsVisible" type="button" @click="swipeRight(2)")
      mr-icon(name="sharp-arrow" style="width:1.25em;")
      span.ada-tooltip previous

    button.right-nav.btn-reset.text-center.clickable.xs-f-large.max-at-tweak(v-if="arrowsVisible" type="button" @click="swipeLeft(2)")
      mr-icon(name="sharp-arrow" style="width:1.25em;")
      span.ada-tooltip next

</template>

<script>
  import { mapState } from 'vuex';
  import HorizontalSelector from "@components/horizontalSelector";
  import bestMatchMixin from '@mixins/bestMatchMixin';

  export default {
    name: "DefaultPdpSwatches",

    components: {
      HorizontalSelector,
    },

    mixins: [bestMatchMixin],
    inject: ['getObjProperty', 'getObjPropertyCatchUndefined'],

    data() {
      return {
        selectedIndex: 0,
        arrowsVisible: false
      };
    },

    computed: {
      ...mapState('pdp', ['product', 'productsForProductType']),
      ...mapState('xsell', ['xsellForActiveColorKitSubs']),
      ...mapState('colorAdvisor', ['rootPerfectionRecommendation']),

      showSwatchSelector() {
        return !!this.product.groupByProductType;
      },

      selectedProductIndex() {
        return this.productsForProductType.findIndex(prod => prod.code == this.product.code);
      }
    },

    watch: {
      product() {
        this.setSelectedIndex();
      },

      productsForProductType() {
        this.setSelectedIndex();
      }
    },

    created() {
      this.setSelectedIndex();
    },

    methods: {
      swatchImage(prod) {
        if (this.getObjProperty(prod, 'imagery.pdpSelector.url')) {
          return prod.imagery.pdpSelector;
        } else if (this.getObjPropertyCatchUndefined(prod, 'imagery.standard.url')) {
          return prod.imagery.standard;
        }

        return {};
      },

      recommendedSwatch(prod) {
        if (prod.product_type == "root_reboot") {
          let match = this.mix_bestMatchObj(prod.product_type);
          return (match && match.code == prod.code);
        }

        if (prod.product_type === "root_perfection") {
          return this.rootPerfectionRecommendation && this.rootPerfectionRecommendation.code === prod.code;
        }

        if (!this.xsellForActiveColorKitSubs || !this.xsellForActiveColorKitSubs.length) {
          return false;
        }

        return this.xsellForActiveColorKitSubs.some(subXsell => {
          if (!subXsell.xsell || !subXsell.xsell.length) {
            return false;
          }
          return subXsell.xsell.some(product => product.code == prod.code);
        });
      },

      selectProduct(prod, index) {
        this.selectedIndex = index;
        this.$router.push('/product/' + prod.url_key).catch(error => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      },

      swipeLeft(num) {
        num = Math.ceil(num);
        if (this.productsForProductType[this.selectedIndex + num]) {
          this.selectedIndex = this.selectedIndex + num;
        }
      },

      swipeRight(num) {
        num = Math.ceil(num);
        if (this.productsForProductType[this.selectedIndex - num]) {
          this.selectedIndex = this.selectedIndex - num;
        }
      },

      setSelectedIndex() {
        if (this.product && this.productsForProductType && this.productsForProductType.length) {
          for (var x = 0; x < this.productsForProductType.length; x++) {
            if (this.productsForProductType[x].code == this.product.code) {
              this.selectedIndex = x;
              break;
            }
          }
        }
      },

      setArrowsVisible(val) {
        this.arrowsVisible = val;
      }
    },
  };
</script>

<style scoped lang="stylus">
  .default-pdp-swatches
    position relative
    width 100%
    overflow hidden
    padding 1em 0
    min-height 5.5em
    
    &.has-arrows
      padding 1em 1.5em

    .swatches-wrap
      position relative
      width 100%
      overflow hidden

      &:before
      &:after
        content ''
        position absolute
        top 0
        bottom 0
        width 1.5em
        pointer-events none
        z-index 2

    .swatch-wrap
      position relative
      display inline-block
      vertical-align top
      width 3em
      text-align center
      white-space normal

      .swatch
        position relative
        display inline-block
        vertical-align top
        border-radius 50%
        overflow hidden
        width 2.5em
        height 2.5em
        margin 0.5em 0
        margin-right 0
        scroll-margin-top 1em

        .scroll-to
          position absolute
          top -2.5em
          left 0
          pointer-events none

        .swatch-image
          width 100%
          border-radius 50%

        .best
          position absolute
          left 50%
          top 50%
          -webkit-transform translateX(-50%) translateY(-50%)
          -ms-transform translateX(-50%) translateY(-50%)
          transform translateX(-50%) translateY(-50%)
          color color-white

      &.selected
        .swatch
          border 2px solid brand-color-1
          
          .swatch-image
            border 2px solid transparent

    .left-nav
    .right-nav
      position absolute
      top 0
      bottom 0
      
    .left-nav
      left -0.25em
      
    .right-nav
      right -0.25em
      
      .mr-icon
        transform rotate(180deg)    

</style>
